// extracted by mini-css-extract-plugin
export default {"container":"_3xK5","dropzone":"LeFV","uploadZoneLabel":"_3vDa","uploadZone":"_1CoA","uploadZoneInput":"_1bOU","icon":"_1ipZ","image":"_2qg0","alert":"_2fKp"};